var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccorditionediticon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 17.2586L11.413 17.2436L21.045 7.7036C21.423 7.3256 21.631 6.8236 21.631 6.2896C21.631 5.7556 21.423 5.2536 21.045 4.8756L19.459 3.2896C18.703 2.5336 17.384 2.5376 16.634 3.2866L7 12.8286V17.2586ZM18.045 4.7036L19.634 6.2866L18.037 7.8686L16.451 6.2836L18.045 4.7036ZM9 13.6626L15.03 7.6896L16.616 9.2756L10.587 15.2466L9 15.2516V13.6626Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 21.2456H19C20.103 21.2456 21 20.3486 21 19.2456V10.5776L19 12.5776V19.2456H8.158C8.132 19.2456 8.105 19.2556 8.079 19.2556C8.046 19.2556 8.013 19.2466 7.979 19.2456H5V5.24561H11.847L13.847 3.24561H5C3.897 3.24561 3 4.14261 3 5.24561V19.2456C3 20.3486 3.897 21.2456 5 21.2456Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccorditionediticon);
export default __webpack_public_path__ + "static/media/accorditionediticon.43fe4396f47e820fda365a896be66bc8.svg";
export { ForwardRef as ReactComponent };